module.exports = __webpack_public_path__ + "static/the-marriage-plot-e929d91a3c978ec5fb73785ed3722e39.jpg";